import React, { useState, useEffect } from 'react';
import DisplayCards from './displayCards'; 
import DisplaySmallCards from './displaySmallCards'; 
import useIsDeviceMobile from "../hooks/useIsDeviceMobile";
import Tooltip from './tooltip';

const PlayerHand = ({ 
  remainingCards, 
  setRemainingCards,
  stand, 
  playerScore, 
  setPlayerScore, 
  playerBlackJack, 
  setPlayerBlackJack, 
  setPlayerScoreSplit1, 
  setPlayerScoreSplit2, 
  blackJackSplit1, 
  setBlackJackSplit1, 
  blackJackSplit2, 
  setBlackJackSplit2,
  balance,
  bet,
  setBalance
}) => {
  const [drawnCards, setDrawnCards] = useState([]);
  const [cardNumbers, setCardNumbers] = useState([]);
  const [gameOver, setGameOver] = useState(false);
  const [blackJack, setBlackJack] = useState(false);
  const [mounted, setMounted] = useState(false);
  const isMobile = useIsDeviceMobile();

  useEffect(() => {
    const storedRemaining = localStorage.getItem("remainingCards");
    const storedDrawnCards = localStorage.getItem("drawnCards");
    const storedCardNumbers = localStorage.getItem("cardNumbers");
  
    if (storedRemaining && storedDrawnCards && storedCardNumbers) {
      setRemainingCards(JSON.parse(storedRemaining));
      setDrawnCards(JSON.parse(storedDrawnCards));
      setCardNumbers(JSON.parse(storedCardNumbers));
    } else {
      // Si no hay datos guardados, repartir dos cartas
      if (remainingCards.length >= 2) {
        const drawnCard1 = remainingCards[0];
        const drawnCard2 = remainingCards[1];
        const cardNumber1 = drawnCard1.slice(0, -1);
        const cardNumber2 = drawnCard2.slice(0, -1);
        setDrawnCards([drawnCard1, drawnCard2]);
        setCardNumbers([cardNumber1, cardNumber2]);
        setRemainingCards(prev => prev.slice(2));
      }
    }
  
    setMounted(true);
  }, []);
  
  useEffect(() => {
    if (mounted) {
      localStorage.setItem("drawnCards", JSON.stringify(drawnCards));
      localStorage.setItem("cardNumbers", JSON.stringify(cardNumbers));
      localStorage.setItem("remainingCards", JSON.stringify(remainingCards));
    }
  }, [drawnCards, cardNumbers, remainingCards, mounted]);

  useEffect(() => {
    if (mounted && drawnCards.length > 0) {
      localStorage.setItem("drawnCards", JSON.stringify(drawnCards));
    }
  }, [drawnCards, mounted]);

  useEffect(() => {
    if (mounted && cardNumbers.length > 0) {
      localStorage.setItem("cardNumbers", JSON.stringify(cardNumbers));
    }
  }, [cardNumbers, mounted]);

  useEffect(() => {
    if (remainingCards.length > 0 && mounted && drawnCards.length === 0) {
      playerCard();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [remainingCards, mounted]);

  const playerCard = () => {
    if (remainingCards.length > 2) {
      const drawnCard = remainingCards[1];
      const drawnSecondCard = remainingCards[2];

      const cardNumber1 = drawnCard.slice(0, -1); 
      const cardNumber2 = drawnSecondCard.slice(0, -1);

      setDrawnCards([drawnCard, drawnSecondCard]);
      setCardNumbers([cardNumber1, cardNumber2]);
      setRemainingCards(prev => prev.slice(2));
      if (cardNumber1 === cardNumber2) {
        setSplitButton(true);
      }
      calculateScore([cardNumber1, cardNumber2]); 
    }
  };

  const calculateScore = (cards = cardNumbers) => {
    let sum = 0;
    let aceCount = 0;

    cards.forEach(card => {
      let value = card;
      if (isNaN(value)) {
        value = (value === 'A') ? 11 : 10;
        if (value === 11) aceCount++;
      } else {
        value = parseInt(value);
      }

      sum += value;
    });

    while (sum > 21 && aceCount > 0) {
      sum -= 10;
      aceCount--;
    }

    setPlayerScore(sum);

    if (sum === 21 && cards.length === 2) {
      setBlackJack(true);
      setPlayerBlackJack(true);
    } else if (sum > 21) {
      setGameOver(true);
    }
  };

  const showNextCard = () => {
    if (remainingCards.length > 0 && !gameOver && !blackJack) {
      const nextCard = remainingCards[0];
      const cardNumber = isNaN(parseInt(nextCard[0])) ? nextCard[0] : nextCard.slice(0, -1);
      setDrawnCards(prev => [...prev, nextCard]);
      setCardNumbers(prev => [...prev, cardNumber]);
      setRemainingCards(prev => prev.slice(1));
    }
  };
  
  useEffect(() => {
    if (cardNumbers.length > 0 && !hasSplit) {
      calculateScore();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardNumbers]);

  // SPLITS
  const [splitButton, setSplitButton] = useState(false);
  const [hasSplit, setHasSplit] = useState(false);
  const [split1Cards, setSplit1Cards] = useState([]);
  const [split2Cards, setSplit2Cards] = useState([]);
  const [split1Numbers, setSplit1Numbers] = useState([]);
  const [split2Numbers, setSplit2Numbers] = useState([]);
  const [gameOverSplit1, setGameOverSplit1] = useState(false);
  const [gameOverSplit2, setGameOverSplit2] = useState(false);

  const showNextCardSplit1 = () => {
    if (remainingCards.length > 0 && !gameOverSplit1 && !blackJackSplit1) {
      const nextCard = remainingCards[0];
      const cardNumber = isNaN(parseInt(nextCard[0])) ? nextCard[0] : nextCard.slice(0, -1);
      setSplit1Cards(prev => [...prev, nextCard]);
      setSplit1Numbers(prev => [...prev, cardNumber]);
      setRemainingCards(prev => prev.slice(1));
    }
  };

  const showNextCardSplit2 = () => {
    if (remainingCards.length > 0 && !gameOverSplit2 && !blackJackSplit2) {
      const nextCard = remainingCards[0];
      const cardNumber = isNaN(parseInt(nextCard[0])) ? nextCard[0] : nextCard.slice(0, -1);
      setSplit2Cards(prev => [...prev, nextCard]);
      setSplit2Numbers(prev => [...prev, cardNumber]);
      setRemainingCards(prev => prev.slice(1));
    }
  };

  const handleSplit = () => {
    let splitCard1 = drawnCards[0];
    let splitCard2 = drawnCards[1];
    const cardNumberSplit1 = splitCard1.slice(0, -1); 
    const cardNumberSplit2 = splitCard2.slice(0, -1); 
    setSplit1Numbers([cardNumberSplit1]);
    setSplit2Numbers([cardNumberSplit2]);
    setSplit1Cards([splitCard1]);
    setSplit2Cards([splitCard2]);
    setHasSplit(true);
    setSplitButton(false);
  };

  useEffect(() => {
    if (split1Numbers.length > 0) {
      calculateSplitScore(split1Numbers, setPlayerScoreSplit1, setBlackJackSplit1, setGameOverSplit1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [split1Numbers]);

  useEffect(() => {
    if (split2Numbers.length > 0) {
      calculateSplitScore(split2Numbers, setPlayerScoreSplit2, setBlackJackSplit2, setGameOverSplit2);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [split2Numbers]);

  const calculateSplitScore = (cards, setScore, setBlackjack, setGameOver) => {
    let sum = 0;
    let aceCount = 0;

    cards.forEach(card => {
      let value = card;
      if (isNaN(value)) {
        value = (value === 'A') ? 11 : 10;
        if (value === 11) aceCount++;
      } else {
        value = parseInt(value);
      }

      sum += value;
    });

    while (sum > 21 && aceCount > 0) {
      sum -= 10;
      aceCount--;
    }

    setScore(sum);

    if (sum === 21 && cards.length === 2) {
      setBlackjack(true);
    } else if (sum > 21) {
      setGameOver(true);
    }
  };

  return (
    <div>
      {!hasSplit && (
        <div className="justify-content-center d-flex">
          {drawnCards.length > 0 && (
            <div>
              <button className="btn btn-dark m-1" onClick={showNextCard} disabled={stand || playerBlackJack || gameOver || remainingCards.length === 0}>
                Pedir carta
              </button>
              <Tooltip text={(bet * 2 > balance) && splitButton ? "No tienes suficiente saldo para dividir la mano." : ""}>
                <button
                  className="btn btn-dark m-1"
                  onClick={handleSplit}
                  disabled={stand || !splitButton || bet * 2 > balance}
                >
                  Split
                </button>
              </Tooltip>
            </div>
          )}
        </div>
      )}

      <div className="justify-content-center d-flex">
        {!hasSplit && drawnCards.map((card, index) => (
          <div key={index} className='p-2 card-wrapper2'>
            {isMobile ? <DisplaySmallCards card={card} /> : <DisplayCards card={card} />}
          </div>
        ))}
      </div>

      {hasSplit && (
        <div className="justify-content-center d-flex flex-column">
          <div className="d-flex justify-content-around">
            <div>
              <button className="btn btn-dark m-1" onClick={showNextCardSplit1} disabled={stand || blackJackSplit1 || gameOverSplit1 || remainingCards.length === 0}>
                Pedir carta Split 1
              </button>
              <div className="d-flex border border-dark rounded">
                {split1Cards.map((card, index) => (
                  <div key={index} className='p-2 card-wrapper2'>
                    {isMobile ? <DisplaySmallCards card={card} /> : <DisplayCards card={card} />}
                  </div>
                ))}
              </div>
            </div>

            <div>
              <button className="btn btn-dark m-1" onClick={showNextCardSplit2} disabled={stand || blackJackSplit2 || gameOverSplit2 || remainingCards.length === 0}>
                Pedir carta Split 2
              </button>
              <div className="d-flex border border-dark rounded">
                {split2Cards.map((card, index) => (
                  <div key={index} className='p-2 card-wrapper2'>
                    {isMobile ? <DisplaySmallCards card={card} /> : <DisplayCards card={card} />}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {drawnCards.length > 0 && (
        <div className="justify-content-center d-flex">
          <h2>Tu mano</h2>
        </div>
      )}
    </div>
  );
};

export default PlayerHand;
